const modals = require('sma.common/components/modals');
const Cookies = require('js-cookie');

const STRINGS = {
	choose_app: gettext('Choose application:'),
	name_application: gettext('Name your application'),
	create_application: gettext('Create application'),
};

class ProgramDetailView extends Backbone.View {
	get events() {
		return {
			'click .sma-js-apps-popover': 'preventEvent',
			'click .sma-js-program-apply': 'applyToProgram',
			'click .sma-js-program-apply-sso': 'saveLocation'
		}
	}

	constructor(config) {
		super();

		this.setElement($('body'));

		this.applications = config.applications;
		this.name_required = config.name_required;
		this.name_instructions = config.name_instructions;

		this.renderPopover();

		this.renderEligibleDialog();
	}

	renderEligibleDialog() {
		let eligibility = new RegExp('eligible=([^&#]*)').exec(window.location.href);

		if (eligibility !== null && eligibility.length > 1) {
			let msg = gettext("Sorry, you aren't eligible for this program");

			if (eligibility[1] == 'True') {
				msg = gettext('You are eligible for this program!');
			}

			let modal = new modals.Notify(
				gettext('Eligibility results'), 
				msg, 
				gettext('Okay'),
				() => {modal.hide()}
			);
		}
	}

	renderPopover() {
		if (this.applications.length < 2) return;
		
		let template = '<div class="popover" role="tooltip">\
			<div class="popover-arrow"></div>\
			<div class="popover-content"></div></div>';

		let content = `<strong>${STRINGS.choose_app}</strong></br>`;

		for (var app of this.applications) {
			content += `<a href="${app.url}">${app.name}</a></br>`;
		}

		$('.sma-js-apps-popover').popover({
			html: true,
			trigger: 'focus',
			container: 'body',
			template: template,
			placement: 'bottom',
			content: content,
		});
	}

	applyToProgram(e) {
		const $btn = $(e.currentTarget);

		// Prevent double-click from firing multiple application-create requests.
		// We disable the button on the very first click regardless of whether a
		// name dialog is required.
		if ($('.sma-js-program-apply').hasClass('sma-js-apply-pending')) {
			e.preventDefault();
			return;
		}
		$('.sma-js-program-apply').addClass('sma-js-apply-pending');

		if (!this.name_required) return;

		e.preventDefault();

		let dlg = new modals.Prompt(
			STRINGS.name_application,
			this.name_instructions,
			(name) => {
				const applyHref = $btn.attr('href');
				const sep = applyHref.indexOf('?') !== -1 ? '&' : '?';
				window.location.href = applyHref + sep + 'name=' + encodeURIComponent(name);
			},
			{
				ok: STRINGS.create_application,
				maxLength: 75
			}
		);
		const ok = dlg.modalFooter.find('.sma-js-notify-ok');
		ok.addClass('disabled');
		$('.sma-js-validate-input').on('input', function() {
			var value = dlg.modalBody.find('.sma-js-validate-input').val();
			ok.toggleClass('disabled', value.length === 0);
		});

		// Re-enable the button when the dialog is dismissed (cancel, close, or OK).
		// Uses smaModalHide because modals.Prompt is not a Bootstrap modal and
		// never fires hide.bs.modal.
		const onDlgHide = (_e, modal) => {
			if (modal === dlg) {
				$(document).off('smaModalHide', onDlgHide);
				$('.sma-js-program-apply').removeClass('sma-js-apply-pending');
			}
		};
		$(document).on('smaModalHide', onDlgHide);
	}

	saveLocation(e) {
		Cookies.set('sma-redirect', window.location.href, {
			expires: 2
		});
	}

	preventEvent(e) {
		e.preventDefault();
	}
}


module.exports = {
	ProgramDetailView: ProgramDetailView
};
